import { v4 as uuidv4 } from "uuid";

function generateNewIds(ps, newDocumentItemId) {
  const newPsId = uuidv4();
  let childrenIdReference = {};
  let newPs = {};
  if (ps?.is_bundle) {
    childrenIdReference = ps?.children?.reduce((acc, current) => {
      acc[current.document_item_product_service_id] = uuidv4();
      return acc;
    }, {});

    newPs = {
      ...ps,
      document_item_product_service_id: newPsId,
      document_item_id: newDocumentItemId,
      product_service_id: uuidv4(),
      bundle_group: {
        items: ps?.bundle_group?.items.map((id) => childrenIdReference[id]) || [],
        default_group_ps_item_id: childrenIdReference[ps?.bundle_group?.default_group_ps_item_id] || ""
      },
      children:
        ps?.children?.map((item) => {
          return {
            ...item,
            document_item_product_service_id: childrenIdReference[item.document_item_product_service_id],
            product_service_parent_id: [newPsId],
            product_service_id: uuidv4(),
            document_item_id: newDocumentItemId
          };
        }) || []
    };
    return {
      newPs,
      childrenIdReference,
      oldPs: ps
    };
  }
  if (ps.is_inside_bundle) {
    newPs = {
      ...ps,
      document_item_product_service_id: newPsId,
      document_item_id: newDocumentItemId,
      product_service_id: uuidv4(),
      is_inside_bundle: false,
      total: Number(ps.sell || 0) * Number(ps.quantity || 1) - Number(ps.discount || 0)
    };
    return {
      newPs,
      childrenIdReference,
      oldPs: ps
    };
  }
  newPs = {
    ...ps,
    document_item_product_service_id: newPsId,
    product_service_id: uuidv4(),
    document_item_id: newDocumentItemId
  };

  return {
    newPs,
    childrenIdReference,
    oldPs: ps
  };
}

export const adjustWidthsProportionally = (items, deduct = true, changedWidth) => {
  const total = items.reduce((sum, item) => sum + Number(item.defaultWidth), 0);

  if (total === 0) return items.map((item) => ({ ...item, width: Number(item.defaultWidth) }));

  return items.map((item) => {
    const proportion = Number(item.defaultWidth) / total;
    const adjustment = proportion * changedWidth;

    return {
      ...item,
      defaultWidth: deduct ? Number(item.defaultWidth) - adjustment : Number(item.defaultWidth) + adjustment
    };
  });
};

export function getDuplicateProductServicesMedia(productServices, generateProductServiceUrl) {
  return productServices
    .reduce((acc, current) => {
      if (current?.oldPs?.is_bundle && current?.oldPs?.children?.length) {
        current.oldPs.children.map((oldChild) => {
          const newChild = current.newPs.children.find(
            (newChild) =>
              current.childrenIdReference[oldChild.document_item_product_service_id] ===
              newChild.document_item_product_service_id
          );
          acc.push({
            from: generateProductServiceUrl(oldChild),
            to: generateProductServiceUrl(newChild)
          });
          return acc;
        });
      }
      acc.push({
        from: generateProductServiceUrl(current.oldPs),
        to: generateProductServiceUrl(current.newPs)
      });
      return acc;
    }, [])
    .filter((psWithPhoto) => Boolean(psWithPhoto?.from));
}

export const defaultPS = {
  category: "",
  category_id: null,
  cost: 0,
  currency_id: 840,
  discount: 0,
  document_item_id: null,
  document_item_product_service_id: null,
  document_item_product_service_parent_id: null,
  include_in_adjustment: true,
  location: null,
  long_description: null,
  manual: null,
  manufacturer: null,
  manufacturer_id: null,
  manufacturer_part_number: null,
  map: "",
  msrp: "",
  optional: false,
  optional_is_selected: false,
  photo: null,
  position: 0,
  quantity: "",
  quantity_adjustment_allowed: false,
  recurrence_id: null,
  recurrence_include_in_total: true,
  recurrence_option_id: 1,
  sell: 0,
  short_description: "",
  specification_sheet: null,
  sub_category: null,
  sub_category_id: null,
  taxable: true,
  tenant_id: null,
  tenant_part_number: null,
  total: 0,
  type: "",
  type_id: null,
  uom: "",
  uom_id: null,
  vendor_id: null,
  vendor_name: null
};

export default generateNewIds;
